import { useSyncExternalStore } from 'react';
import { getInstallState, subscribeInstall, type InstallState } from '../services/install';

// Стейт установки (barter-025): слушатели beforeinstallprompt/appinstalled
// вешает initInstall (main.tsx) — здесь только подписка React на модуль-сторе.

export function useInstall(): InstallState {
  return useSyncExternalStore(subscribeInstall, getInstallState, getInstallState);
}
